<nz-divider [nzText]="travelers2" nzOrientation="center">
  <ng-template #travelers2>
    <h5>{{ 'PERSONAL_DATA_FORM.RESIDENCE_CARD_OR_DOCUMENT_AUTHORIZING_2' | translate }}</h5>
  </ng-template>
</nz-divider>
<div class="row">
  @if (controls.entryDocumentSeries; as entryDocumentSeries) {
    <div class="standard-form-field entryDocumentSeries-field">
      <label
        for="entryDocumentSeriesInput"
        [class.invalid]="entryDocumentSeries.touched && entryDocumentSeries.invalid">
        {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-SERIES.MAIN-LABEL' | translate }}
      </label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="entryDocumentSeriesInput"
          type="text"
          maxLength="100"
          placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-SERIES.PLACEHOLDER' | translate }}"
          [formControl]="entryDocumentSeries"
          [attr.aria-required]="false"
          [attr.aria-invalid]="entryDocumentSeries.touched && entryDocumentSeries.invalid ? 'true' : null"
          [attr.aria-describedby]="
            entryDocumentSeries.touched && entryDocumentSeries.invalid ? 'entryDocumentSeriesError' : null
          " />
        @if (entryDocumentSeries.touched && entryDocumentSeries.invalid) {
          <mat-error id="entryDocumentSeriesError">
            {{ entryDocumentSeries.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.entryDocumentNumber; as entryDocumentNumber) {
    <div class="standard-form-field entryDocumentNumber-field">
      <label
        for="entryDocumentNumberInput"
        [class.invalid]="entryDocumentNumber.touched && entryDocumentNumber.invalid">
        {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-NUMBER.MAIN-LABEL' | translate }}
      </label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="entryDocumentNumberInput"
          type="text"
          maxLength="100"
          placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-NUMBER.PLACEHOLDER' | translate }}"
          [formControl]="entryDocumentNumber"
          [attr.aria-required]="false"
          [attr.aria-invalid]="entryDocumentNumber.touched && entryDocumentNumber.invalid ? 'true' : null"
          [attr.aria-describedby]="
            entryDocumentNumber.touched && entryDocumentNumber.invalid ? 'entryDocumentNumberError' : null
          " />
        @if (entryDocumentNumber.touched && entryDocumentNumber.invalid) {
          <mat-error id="entryDocumentNumberError">
            {{ entryDocumentNumber.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.entryDocumentIssueDate; as entryDocumentIssueDate) {
    <div class="standard-form-field entryDocumentIssueDate-field">
      <label
        for="entryDocumentIssueDateInput"
        [class.invalid]="entryDocumentIssueDate.touched && entryDocumentIssueDate.invalid">
        {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-ISSUE-DATE.MAIN-LABEL' | translate }}
      </label>
      <mat-form-field appearance="outline" (click)="entryDocumentIssueDatePicker.open()">
        <input
          matInput
          (focus)="entryDocumentIssueDatePicker.open()"
          id="entryDocumentIssueDateInput"
          #applicantEntryDocumentIssueDate
          [matDatepicker]="entryDocumentIssueDatePicker"
          placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-ISSUE-DATE.PLACEHOLDER' | translate }}"
          [min]="minValidDate"
          [max]="maxValidDate"
          [readonly]="true"
          [attr.aria-required]="false"
          [attr.aria-invalid]="entryDocumentIssueDate.touched && entryDocumentIssueDate.invalid ? 'true' : null"
          [attr.aria-describedby]="
            entryDocumentIssueDate.touched && entryDocumentIssueDate.invalid ? 'entryDocumentIssueDateError' : null
          "
          [formControl]="entryDocumentIssueDate" />
        <mat-datepicker-toggle
          matSuffix
          [for]="entryDocumentIssueDatePicker"
          aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
        </mat-datepicker-toggle>
        <mat-datepicker
          #entryDocumentIssueDatePicker
          [startView]="'month'"
          [startAt]="entryDocumentIssueDate.value || documentIssuePickerStartDate"
          (closed)="applicantEntryDocumentIssueDate.blur()">
        </mat-datepicker>
        @if (entryDocumentIssueDate.touched && entryDocumentIssueDate.invalid) {
          <mat-error id="entryDocumentIssueDateError">
            {{ entryDocumentIssueDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.entryDocumentExpiryDate; as entryDocumentExpiryDate) {
    <div class="standard-form-field entryDocumentExpiryDate-field">
      <label
        for="entryDocumentExpiryDateInput"
        [class.invalid]="entryDocumentExpiryDate.touched && entryDocumentExpiryDate.invalid">
        {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-EXPIRY-DATE.MAIN-LABEL' | translate }}
      </label>
      <mat-form-field appearance="outline" (click)="entryDocumentExpiryDatePicker.open()">
        <input
          matInput
          (focus)="entryDocumentExpiryDatePicker.open()"
          id="entryDocumentExpiryDateInput"
          #applicantEntryDocumentExpiryDate
          [matDatepicker]="entryDocumentExpiryDatePicker"
          placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-EXPIRY-DATE.PLACEHOLDER' | translate }}"
          [min]="minValidDate"
          [max]="maxValidFutureDate"
          [readonly]="true"
          [formControl]="entryDocumentExpiryDate"
          [attr.aria-required]="false"
          [attr.aria-invalid]="entryDocumentExpiryDate.touched && entryDocumentExpiryDate.invalid ? 'true' : null"
          [attr.aria-describedby]="
            entryDocumentExpiryDate.touched && entryDocumentExpiryDate.invalid ? 'entryDocumentExpiryDateError' : null
          " />
        <mat-datepicker-toggle
          matSuffix
          [for]="entryDocumentExpiryDatePicker"
          aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
        </mat-datepicker-toggle>
        <mat-datepicker
          #entryDocumentExpiryDatePicker
          [startView]="'month'"
          [startAt]="entryDocumentExpiryDate.value || documentExpiryPickerStartDate"
          (closed)="applicantEntryDocumentExpiryDate.blur()">
        </mat-datepicker>
        @if (entryDocumentExpiryDate.touched && entryDocumentExpiryDate.invalid) {
          <mat-error id="entryDocumentExpiryDateError">
            {{ entryDocumentExpiryDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.entryDocumentIssuingAuthority; as entryDocumentIssuingAuthority) {
    <div class="standard-form-field widened-field entryDocumentIssuingAuthority-field">
      <label
        for="entryDocumentIssuingAuthorityInput"
        [class.invalid]="entryDocumentIssuingAuthority.touched && entryDocumentIssuingAuthority.invalid">
        {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-ISSUING-AUTHORITY.MAIN-LABEL' | translate }}
      </label>
      <mat-form-field appearance="outline">
        <input
          matInput
          id="entryDocumentIssuingAuthorityInput"
          type="text"
          minLength="1"
          maxLength="100"
          placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-ISSUING-AUTHORITY.PLACEHOLDER' | translate }}"
          [formControl]="entryDocumentIssuingAuthority"
          [attr.aria-required]="false"
          [attr.aria-invalid]="
            entryDocumentIssuingAuthority.touched && entryDocumentIssuingAuthority.invalid ? 'true' : null
          "
          [attr.aria-describedby]="
            entryDocumentIssuingAuthority.touched && entryDocumentIssuingAuthority.invalid
              ? 'entryDocumentIssuingAuthorityError'
              : null
          " />
        @if (entryDocumentIssuingAuthority.touched && entryDocumentIssuingAuthority.invalid) {
          <mat-error id="entryDocumentIssuingAuthorityError">
            {{ entryDocumentIssuingAuthority.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
</div>
